import { vModelText as _vModelText, withKeys as _withKeys, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "my-4",
  id: "lightweightSearch"
}
const _hoisted_2 = { class: "h-12 bg-white dark:bg-gray-700 flex items-center rounded-full shadow-xl" }
const _hoisted_3 = { class: "bg-white dark:bg-gray-700 rounded-full" }
const _hoisted_4 = { class: "pr-4 bg-white dark:bg-gray-700 rounded-full" }
const _hoisted_5 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _withDirectives(_createVNode("input", {
        class: "h-12 rounded-l-full w-full\n\t\t\tpy-4 px-6 font-medium text-gray-700 dark:text-gray-400 leading-tight focus:outline-none bg-white dark:bg-gray-700",
        id: "search",
        type: "text",
        placeholder: _ctx.searchPlaceholder,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.modelValue = $event)),
        onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.setSearchValue && _ctx.setSearchValue(...args))),
        onKeypress: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args))),
        onKeyup: _cache[4] || (_cache[4] = _withKeys(
//@ts-ignore
(...args) => (_ctx.searchRouting && _ctx.searchRouting(...args)), ["enter"])),
        onKeydown: [
          _cache[5] || (_cache[5] = _withKeys(
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)), ["delete"])),
          _cache[6] || (_cache[6] = _withKeys(
//@ts-ignore
(...args) => (_ctx.resetSearch && _ctx.resetSearch(...args)), ["esc"]))
        ]
      }, null, 40, ["placeholder"]), [
        [_vModelText, _ctx.modelValue]
      ]),
      _createVNode("div", _hoisted_3, [
        (_ctx.enableSaveSearchValueInStorage ? _ctx.searchValue : _ctx.localSearchValue)
          ? (_openBlock(), _createBlock("div", {
              key: 0,
              class: "pl-6 pt-1.5 mr-2 bg-white dark:bg-gray-700 py-2 focus:outline-none text-2xl w-12 h-12\n\t\t\t\ttext-gray-700 dark:text-gray-400 cursor-pointer",
              title: _ctx.resetSearch,
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.resetSearch && _ctx.resetSearch(...args)))
            }, "x ", 8, ["title"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode("button", {
          "aria-label": "start search",
          class: "bg-white dark:bg-gray-700 p-2 focus:outline-none w-12 h-12\n\t\t\t\ttext-gray-700 dark:text-gray-400",
          onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.searchRouting && _ctx.searchRouting(...args))),
          style: {"border-bottom-right-radius":"9999px","border-top-right-radius":"9999px"}
        }, [
          _hoisted_5
        ])
      ])
    ])
  ]))
}